// OurProductsListing.js
import React from 'react';
import productCardGradients from '../../../common/Utils/Utils';
import { useAlert } from '../../../common/Context/AlertContext';
import { useLoader } from '../../../common/Context/LoaderContext';
import { useProductData } from '../../../common/functions/userProductData/UserProductData';
import CategoryPillsRow from './CategoryPillsRow';
import ProductCard from './ProductCard';
import TrylayoutBanner from '../tryNow/TrylayoutBanner';
import SearchField from './SearchField';
import EmptyState from '../../emptyState/EmptyState';

function OurProductsListing({
  user,
  products,
  subproductscategory,
  selectedCategory,
}) {
  const { showAlert } = useAlert();
  const { setLoading } = useLoader();
  // const { products, subproductscategory, selectedCategory } = useProductData(
  //   showAlert,
  //   setLoading
  // );
  const [searchTerm, setSearchTerm] = React.useState('');

  // Filtered products based on search
  const filteredProducts = products.filter(
    (product) =>
      product.productTitle?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.productSubTitle?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <TrylayoutBanner>
        <div className="position-relative zi_10 ">
          <h1 className="text-center font_40 font_600 mb-4 text-white">
            Our Prodcts
          </h1>
          <div className="d-flex justify-content-center">
            <div className="d-flex justify-content-center align-items-center gap-2">
              <SearchField
                style={{ minWidth: 400 }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
      </TrylayoutBanner>
      <div className="py-4 overflow-hidden">
        <div className="d-flex flex-wrap gap-2 align-items-center justify-content-center">
          <CategoryPillsRow
            subproductscategory={subproductscategory}
            selectedCategory={selectedCategory}
          />
        </div>
      </div>
      <div className="row mt-1 pt-3">
        {filteredProducts.length === 0 ? (
          <EmptyState description="Nothing to display" />
        ) : (
          filteredProducts.map((product, index) => (
            <ProductCard
              key={product.id}
              product={product}
              backgroundGradient={
                productCardGradients[index % productCardGradients.length]
              }
            />
          ))
        )}
      </div>
    </>
  );
}

export default React.memo(OurProductsListing);
